/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { mapDispatch } from '../utils/util';
import './Company.css';
import Wrapper from './Wrapper';

import {
  getCompany,
} from '../actions';


class Room extends Component {
  render() {
    let room = this.props.room;
    let location = this.props.location;

    let url = '/r/' + room.slug + '/' + room.id;

    return (
      <div className="room">
        <div className="room-name">{room.name}</div>
        <div className="num-players">
          {!!(room.minPeople && room.maxPeople) && <span>{room.minPeople}-{room.maxPeople} players</span>}
          {!!room.minutes && <span>, {room.minutes} minutes</span>}
        </div>
        <div className="description">{(room.description || '').replace(/\n+/, '\n')}</div>
        <Link to={url}><Button>More Info</Button></Link>
      </div>
      
    )
  }
}


class Location extends Component {
  render() {
    let location = this.props.location;
    let company = this.props.company;

    let nodes = location.rooms.map(room => <Room key={room.id} room={room} location={location} />);

    return (
      <div className="location">
        <div className="location-info">
          <div className="location-city">{company.name} in {location.city.fullName}</div>
          <div className="location-address">{location.address}</div>
        </div>
        <div className="location-rooms">
          {nodes}
        </div>
      </div>
    )
  }
}


class Company extends OzComponent {

  static need = [
    ['company', getCompany, p => p.id],
  ];

  state = {};

  renderCompany() {
    let company = this.props.company;

    if (!company) {
      return null;
    }

    let nodes = company.locations.map(location => <Location
                                                    key={location.id}
                                                    location={location}
                                                    company={company} />)

    return (
      <div className="company">
        <div className="company-locations">
          {nodes}
        </div>
      </div>
    );
  }

  render() {
    let company = this.props.company || {};

    return (
      <Wrapper className="Company" title={company.name}>
        <Helmet>
          <title>EscapeSpy</title>
        </Helmet>

        {this.renderCompany()}

      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    company: state.get.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getCompany,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Company);



/** WEBPACK FOOTER **
 ** ./src/components/Company.js
 **/